<template>
    <div>
        <div class="d-flex justify-content-between align-items-center row">
            <div class="col-sm-12 col-md-1">
                <select style="width:60px !important" class="form-control" v-model="tableData.length" @change="changePerPage()">
                    <option v-for="(records, index) in perPage" :key="index" :value="records">{{records}}</option>
                </select>
            </div>
            <div class="mb-2 col-md-3 text-right">
                <input class="form-control" type="text" v-model="tableData.search"
                   @input="getSearch()">
            </div>
        </div>
        <v-table :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy">
            <tbody>
                <tr class="pointer" @click="showDetail(prospect.id)" v-for="prospect in prospects" :key="prospect.id">
                    <td>{{prospect.last_name}}</td>
                    <td>{{prospect.first_name}}</td>
                    <td>{{prospect.phone}}</td>
                    <td>{{prospect.email}}</td>
                    <td>
                        <span style="color: black" class="badge badge-pill badge-light" v-if="prospect.status == null">Nouveau</span>
                        <span class="badge badge-pill badge-success" v-if="prospect.status == '1'">Activé</span>
                        <span class="badge badge-pill badge-danger" v-if="prospect.status == '0'">Rejeté</span>
                    </td>
                </tr>
            </tbody>
        </v-table>
        <v-paginate :links="links" :navigationFunction="navigation"/>
        <!-- <v-paginate :pagination="pagination"
            @prev="getPrev(pagination.prevPageUrl)"
            @next="getNext(pagination.nextPageUrl)">
        </v-paginate> -->
    </div>
</template>

<script>
import {api, _buildQuery } from "../../../../helpers/shared";
import vTable from '../../../../components/vTable/vTable.vue';
/* import vPaginate from '../../../../components/vTable/vPaginate.vue' */
import vPaginate from '../../../../components/vTable/vPaginate1.vue'
import axios from 'axios';
import  debounce  from 'lodash/debounce'
export default {
    components:{
        vTable, vPaginate
    },
    mounted(){
        this.getProspects()
    },
    data() {
        let sortOrders = {};
        let columns = [
            {width: '33%', label: 'Nom', name: 'last_name' },
            {width: '33%', label: 'Prénom(s)', name: 'first_name'},
            {width: '33%', label: 'Téléphone', name: 'phone'},
            {width: '33%', label: 'Email', name: 'email'},
            {width: '33%', label: 'Statut', name: 'status'}
        ];
        return {
            links:[],
            prospects: [],
            columns: columns,
            sortKey: '',
            sortOrders: sortOrders,
            perPage: ['10', '20', '30'],
            tableData: {
                page: 0,
                length: 10,
                search: '',
                column: 0,
                dir: 'desc',
                state: 'all'
            },
        }
    },
    methods: {
        showDetail(uuid){
            this.$router('/administration/prospects/'+uuid+'.content')
        },
        getWithProduct(val){
            this.tableData.product = val;
            this.changePerPage();
        },
        changePerPage(url = 'administration/prospects'){
            this.tableData.page = 1;
            axios.get(api(url), {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.prospects = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getNext(url){
            this.tableData.page ++;
            axios.get(url, {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.prospects = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getPrev(url){
            this.tableData.page --;
            axios.get(url, {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.prospects = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getProspects(url = 'administration/prospects') {
            let loader = this.$loading.show({
                container: null,
                canCancel: false,
                color: "#4B4B4B",
                backgroundColor: "#4B4B4B",
                height: 35,
                width: 35,
                loader: "bars",
                opacity: 0.3,
            });
            this.tableData.page++;
            axios.get(api(url), {params: this.tableData})
                .then(response => {
                    loader.hide();
                    let content = response.data;
                    this.prospects = content.data;
                    //console.log("Valeur de content dans prospect:",content)
                    this.configPagination(content);
                })
                .catch(errors => {
                    console.log(errors);
                });
        },
        configPagination(data) {
            this.links = data.links;
        },
        sortBy(key) {
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
            this.getProspects();
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },
        getSearch: debounce(function (e) {
            this.changePerPage()
        }, 500),
        navigation(page) {
            this.tableData.page = page;
            axios.get(api('administration/prospects'), {params: this.tableData})
                .then(response => {
                    let content = response.data;
                    this.prospects = content.data;
                    this.configPagination(content);
                })
                .catch(errors => {
                    console.log(errors);
                });
        },

    }
}
</script>

<style lang="scss" scoped>
    .pointer{
        cursor: pointer;
    }
</style>
